module.exports = __webpack_public_path__ + "stu-res/img/male@3x.24e3a18e.png";